import multiGuard from '@/router/utils/vue-router-multiguard'
import checkTokenGuard from '@/router/guards/check-token-guard'
import authGuard from '@/router/guards/auth-guard'
import LayoutFull from '@/layouts/full/LayoutFull.vue'
import PAGE_FEATURES from '@/constants/page-features'
import checkPageFeaturesGuard from '@/router/guards/check-page-features-guard'
import checkAddPageGuard from '@/router/guards/check-add-page-guard'

export default [
  {
    path: '/webview',
    component: LayoutFull,
    beforeEnter: multiGuard([checkTokenGuard, authGuard, checkAddPageGuard, checkPageFeaturesGuard]),
    children: [
      {
        path: 'templates',
        name: 'owner:webview-templates',
        meta: { pageFeatures: [PAGE_FEATURES.BOT, PAGE_FEATURES.STORE] },
        component: () => import(/* webpackChunkName: "webview" */ '@/views/owner-fb/webview/templates/TemplatesTable.vue'),
      },
      {
        path: 'templates/template/:id?',
        name: 'owner:webview-template',
        meta: { pageFeatures: [PAGE_FEATURES.BOT, PAGE_FEATURES.STORE] },
        component: () => import(/* webpackChunkName: "webview" */ '@/views/owner-fb/webview/templates/ProcessTemplate.vue'),
      },
      {
        path: 'requests',
        name: 'owner:webview-requests',
        meta: { pageFeatures: [PAGE_FEATURES.BOT, PAGE_FEATURES.STORE] },
        component: () => import(/* webpackChunkName: "webview" */ '@/views/owner-fb/webview/requests/RequestsTable.vue'),
      },
    ],
  },
]
